(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["not-on-air-home"] && !Shopify.designMode) return;
  try {
    
  async function syncLatestPhoto() {
    for (const target of document.querySelectorAll('[data-noa-latest-source]')) {
      if (target.dataset.loading === 'true') continue;
      target.dataset.loading = 'true';
      try {
        const response = await fetch(target.dataset.noaLatestSource, { credentials: 'same-origin' });
        if (!response.ok) throw new Error('Gallery unavailable');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const source = doc.querySelector('.noa-v2-photo-feature__main');
        if (!source) throw new Error('Gallery missing');
        const card = source.cloneNode(true);
        card.removeAttribute('data-shopify-editor-block');
        card.className = 'noa-card noa-card--photo';
        const mapping = {'noa-v2-card__media':'noa-card__media','noa-v2-card__body':'noa-card__body','noa-v2-card__kicker':'noa-card__kicker','noa-v2-card__title':'noa-card__title','noa-v2-card__meta':'noa-card__meta','noa-v2-card__link':'noa-card__link'};
        for (const [from,to] of Object.entries(mapping)) for (const el of card.querySelectorAll('.'+from)) el.classList.replace(from,to);
        target.replaceChildren(card);
      } catch (error) { target.dataset.loading = 'false'; }
    }
  }
  syncLatestPhoto();
  document.addEventListener('shopify:section:load', syncLatestPhoto);

  } catch(e) { console.error(e); }
})();
})();
